/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSubmittedTrustdockData200ResponseOrganizationUsersInner
 */
export interface GetSubmittedTrustdockData200ResponseOrganizationUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseOrganizationUsersInner
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseOrganizationUsersInner
     */
    'userMailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseOrganizationUsersInner
     */
    'userPrivilege': GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum;
}

export const GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum = typeof GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum[keyof typeof GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum];


